import type {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http'
import {Injectable, inject} from '@angular/core'
import {TranslateService} from '@ngx-translate/core'
import {type Observable, throwError} from 'rxjs'
import {APIResponse} from '@cart/src/app/entities/modals/api-modals/response.modal'
import {NetWatchService} from '@services/net-watch.service'

@Injectable({
  providedIn: 'root',
})
export class NeterrorInterceptor implements HttpInterceptor {
  readonly #netwatchService = inject(NetWatchService)
  readonly #translate = inject(TranslateService)

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isTranslationRequst = request.url.indexOf('/assets/i18n/') !== -1
    if (!isTranslationRequst && !this.#netwatchService.hasInternet()) {
      const errorResponce = new APIResponse()
      errorResponce.message = this.#translate.instant('disconnect')
      errorResponce.status = false
      return throwError(errorResponce)
    } else {
      return next.handle(request)
    }
  }
}
